import { useEffect, useRef, type RefObject } from 'react'

import type { LeadPayload } from '~/widgets/CostBomDemo/hooks/useCostModelLead'

import { runLegacyEngine } from '~/widgets/CostBomDemo/engine/runLegacyEngine'

interface UseCostModelDemoOptions {
  rootRef: RefObject<HTMLElement | null>
  productImages: Record<string, string>
  onLead: (lead: LeadPayload) => void
}

/**
 * Wires the legacy cm2 generation engine + BOM panels once the hero DOM is mounted.
 */
export function useCostModelDemo({
  rootRef,
  productImages,
  onLead,
}: UseCostModelDemoOptions) {
  const onLeadRef = useRef(onLead)
  onLeadRef.current = onLead

  useEffect(() => {
    const root = rootRef.current
    if (!root) return

    runLegacyEngine({
      root,
      productImages,
      onLead: (lead) => onLeadRef.current(lead),
    })
  }, [rootRef, productImages])
}
